import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { flatDeep, getHrefParams } from '@/utils/utils'

// 1.异步权限路由
import asyncRoutes from './asyncRoutes'
// 2.公共权限路由
import commonRoutes from './commonRoutes'

let loading = null

Vue.use(VueRouter)

const routes = [
  ...commonRoutes,
  ...asyncRoutes
]
// 根据 id 匹配路由名
function getNameById (routes, corporbankId) {
  let name
  for (let i = 0; i < routes.length; i++) {
    const item = routes[i]
    if (item.meta && item.meta.id) {
      if (item.meta.id === corporbankId) {
        name = item.name
        break
      } else if (item.children) {
        const result = getNameById(item.children, corporbankId)
        result && (name = result)
      }
    }
  }
  return name
}

// 解决VueRouter报错 Avoided redundant navigation to current location
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  const { corporbankId } = location
  // 可根据id进行路由跳转
  if (corporbankId) {
    const name = getNameById(routes, corporbankId)
    return originalPush.call(this, {
      ...location,
      name
    }).catch(err => err)
  }
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function (location) {
  const { corporbankId } = location
  // 可根据id进行路由跳转
  if (corporbankId) {
    const name = getNameById(routes, corporbankId)
    return originalReplace.call(this, {
      ...location,
      name
    }).catch(err => err)
  }
  return originalReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  loading = Vue.prototype.$tloading()
  const { login: { loginInfo }, nav: { levelOneList } } = store.state
  const { redirect_uri: redirectUri } = getHrefParams()
  // 1.登录校验
  if (!loginInfo.EMP_SID && to.name !== 'Login') {
    if (redirectUri) {
      next({
        name: 'Login',
        query: {
          // 由于vue-router会默认对参数进行encodeURIComponent操作 所以这里进行解码 否则会导致参数中的%符号后面多25
          redirect_uri: window.decodeURIComponent(redirectUri)
        }
      })
    } else {
      // 登录指南 在未登录的状态下可以进入
      const nameList = ['LoginGuide']
      if (nameList.includes(to.name)) {
        next()
      } else {
        next({
          name: 'Login'
        })
      }
    }
  } else {
    next()
  }
  if (loginInfo.EMP_SID && to.name === 'Login') {
    if (redirectUri) {
      next({
        name: 'Home',
        query: {
          // 解码原因同上
          redirect_uri: window.decodeURIComponent(redirectUri)
        }
      })
    } else {
      next({
        name: 'Home'
      })
    }
  } else {
    next()
  }
  // 2.权限校验
  const flatList = [
    ...flatDeep(commonRoutes),
    ...flatDeep(levelOneList)
  ]
  const matchedRoutes = to.matched
  // 因为企业网银现在只做了两层的权限管理 所以to.matched的判断只涉及0 1 2+
  if (matchedRoutes.length === 0) {
    console.log(to, 1)
    next({ name: '404' })
  } else if (matchedRoutes.length === 1 && !flatList.some(item => item.name === to.matched[0].name)) {
    console.log(to, 2)
    next({ name: '404' })
  } else if (matchedRoutes.length >= 2 && (!flatList.some(item => item.name === to.matched[0].name) || !flatList.some(item => item.name === to.matched[1].name))) {
    console.log(to, 3)
    next({ name: '404' })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  loading.close()
  const matchedRoutes = to.matched.map(item => {
    const { name, path, meta } = item
    return {
      name,
      path,
      meta
    }
  })
  // 1.路由影响顶部菜单状态 最多三级 所以判断 matchedRoutes 的长度最长为3
  const activeLevelOneId = matchedRoutes[0] ? matchedRoutes[0].meta.id : ''
  const activeLevelTwoId = matchedRoutes[1] ? matchedRoutes[1].meta.id : ''
  const activeLevelThreeId = matchedRoutes[2] ? matchedRoutes[2].meta.id : ''
  store.commit('nav/SET_ALL', {
    activeLevelOneId,
    activeLevelTwoId,
    activeLevelThreeId
  })
  // 2.路由影响侧边栏 => 由store中的 sidebarList 控制
  const { levelOneList } = store.state.nav
  if (activeLevelTwoId) {
    const levelTwoList = levelOneList.filter(item => item.children && item.children.some(i => i.meta.id === activeLevelTwoId))
    if (levelTwoList && levelTwoList.length) {
      // 二级菜单可能有多个 这里再过滤一次
      const { children } = levelTwoList[0]
      const sidebarList = children.filter(item => item.meta.id === activeLevelTwoId)
      // const sidebarList = children.length > 1 ? levelTwoList : children
      store.commit('nav/SET_ALL', {
        sidebarList
      })
    }
  }
  // 3.路由影响面包屑
  store.commit('nav/SET_ALL', {
    matchedRoutes
  })
})

export default router
